const CATALOGUE_BASE = "https://fe-email-templates.preview.soenergy.co"

// Maps communication_name → {directory}/{templateName} in the email catalogue.
// Source: email-templates/src/emails/**/*.mjml (April 2026, renames added Sep 2026 - SO-33021).
// Ambiguity: `leaving_us` exists in both ark/ and mandrill/ — defaulting to ark/.
// This is a manually maintained snapshot with no drift protection against either repo -
// expect it to go stale again as communication_names get renamed or added.
const EMAIL_TEMPLATE_PATHS: Record<string, string> = {
  "9month_usage": "ark/9month_usage",
  abandon_cart_renewals_reminder: "comms-hub/abandon_cart_renewals_reminder",
  account_recovery_confirmation: "comms-hub/account_recovery_confirmation",
  amr_device_installation: "comms-hub/amr_device_installation",
  annual_statement: "ark/annual_statement",
  automated_payment_review: "comms-hub/automated_payment_review",
  automated_refund_keep: "comms-hub/automated_refund_keep",
  automated_refund_standalone_above_500:
    "comms-hub/automated_refund_standalone_above_500",
  automated_refund_standalone_below_500:
    "comms-hub/automated_refund_standalone_below_500",
  automated_renewals_14_day_reminder:
    "comms-hub/automated_renewals_14_day_reminder",
  automated_renewals_30_day_reminder:
    "comms-hub/automated_renewals_30_day_reminder",
  // Renamed communication_names (SO-33021).
  renewal_reminder_14_days: "comms-hub/automated_renewals_14_day_reminder",
  renewal_reminder_30_days: "comms-hub/automated_renewals_30_day_reminder",
  Bill: "ark/Bill",
  brand_announcement: "mandrill/brand_announcement",
  business_survey: "legacy/business_survey",
  cancellation_email: "comms-hub/cancellation_email",
  cart_abandonment: "mandrill/cart_abandonment",
  change_mode_confirmation: "smart-pay-as-you-go/change_mode_confirmation",
  change_mode_success: "smart-pay-as-you-go/change_mode_success",
  change_of_mode_assignment: "smart-pay-as-you-go/change_of_mode_assignment",
  change_of_mode_reminder: "smart-pay-as-you-go/change_of_mode_reminder",
  complaint_holding_comms: "comms-hub/complaint_holding_comms",
  contact_field_update: "comms-hub/contact_field_update",
  cooling_off_reminder: "comms-hub/cooling_off_reminder",
  cot_move_in_into_your_property: "comms-hub/cot_move_in_into_your_property",
  cot_move_in_welcome: "comms-hub/cot_move_in_welcome",
  cot_move_out_submitted: "comms-hub/cot_move_out_submitted",
  dd_high_debt: "comms-hub/dd_high_debt",
  dd_review_fixed_tariff_elec: "comms-hub/dd_review_fixed_tariff_elec",
  dd_review_fixed_tariff_no_elec: "comms-hub/dd_review_fixed_tariff_no_elec",
  dd_review_variable_tariff_elec: "comms-hub/dd_review_variable_tariff_elec",
  dd_review_variable_tariff_no_elec:
    "comms-hub/dd_review_variable_tariff_no_elec",
  dd_setub_never_paid: "comms-hub/dd_setub_never_paid",
  // Renamed communication_names for the dd_review_* templates (SO-33021).
  fixed_electric_payment_review: "comms-hub/dd_review_fixed_tariff_elec",
  fixed_gas_only_payment_review: "comms-hub/dd_review_fixed_tariff_no_elec",
  variable_electric_payment_review: "comms-hub/dd_review_variable_tariff_elec",
  variable_gas_only_payment_review:
    "comms-hub/dd_review_variable_tariff_no_elec",
  dd_signup_cancellation: "comms-hub/dd_signup_cancellation",
  debt_recovery_different_date: "comms-hub/debt_recovery_different_date",
  debt_recovery_same_date: "comms-hub/debt_recovery_same_date",
  deposit_received_email: "comms-hub/deposit_received_email",
  dispute_raised_elec: "ark/dispute_raised_elec",
  dispute_raised_gas: "ark/dispute_raised_gas",
  domestic_enrolment_error: "enrolment-error/domestic_enrolment_error",
  dunning_automation_report: "comms-hub/dunning_automation_report",
  Elmo_Mail_Out: "mandrill/Elmo_Mail_Out",
  energy_saving_tips_1_with_image: "mandrill/energy_saving_tips_1_with_image",
  energy_saving_tips_2_with_image: "mandrill/energy_saving_tips_2_with_image",
  ET_noET: "ark/ET_noET",
  ET_yesET: "ark/ET_yesET",
  ev_charger_quote_confirmation: "comms-hub/ev_charger_quote_confirmation",
  ev_registration: "comms-hub/ev_registration",
  exclusive_tariff_notification: "comms-hub/exclusive_tariff_notification",
  feedback: "freshdesk/feedback",
  first_campiagn_email: "ark-smbp/first_campiagn_email",
  first_follow_up_leads_pipeline_deals:
    "comms-hub/first_follow_up_leads_pipeline_deals",
  first_follow_up_pipedrive_deals: "comms-hub/first_follow_up_pipedrive_deals",
  // Missing sibling of second_/third_follow_up_sales_pipeline_deals below (SO-33021).
  first_follow_up_sales_pipeline_deals:
    "comms-hub/first_follow_up_sales_pipeline_deals",
  fixed_rate_customer_with_epg: "ark/fixed_rate_customer_with_epg",
  fixed_rate_customer_without_epg: "ark/fixed_rate_customer_without_epg",
  fixed_rate_customer: "freshdesk/fixed_rate_customer",
  freephone_line: "mandrill/freephone_line",
  gas_safety_check: "mandrill/gas_safety_check",
  gengame_cancellation: "gengame/gengame_cancellation",
  gengame_recruitment: "mandrill/gengame_recruitment",
  green_energy_distance_dummy: "legacy/green_energy_distance_dummy",
  green_energy_distance: "legacy/green_energy_distance",
  homecare_pilot: "so-energy-homecare/homecare_pilot",
  homeserve_ABboilercover: "homeserve/homeserve_ABboilercover",
  homeserve_ABeleccover: "homeserve/homeserve_ABeleccover",
  homeserve_eleccover_short: "homeserve/homeserve_eleccover_short",
  homeserve: "homeserve/homeserve",
  imbp_booking_confirmation: "ark-imbp/imbp_booking_confirmation",
  imbp_cancellation: "ark-imbp/imbp_cancellation",
  junifer_6mDD_large_increase_wreads:
    "junifer/junifer_6mDD_large_increase_wreads",
  junifer_6mDD_noreads_nochange: "junifer/junifer_6mDD_noreads_nochange",
  junifer_6mDD_read_request: "junifer/junifer_6mDD_read_request",
  junifer_6mDD_Vlarge: "junifer/junifer_6mDD_Vlarge",
  junifer_6mDD_wreads_nochange: "junifer/junifer_6mDD_wreads_nochange",
  junifer_ADDACS_invalid_account: "junifer/junifer_ADDACS_invalid_account",
  junifer_annual_statement: "junifer/junifer_annual_statement",
  junifer_ARUDD_dispute: "junifer/junifer_ARUDD_dispute",
  junifer_ARUDD_retry_notice2: "junifer/junifer_ARUDD_retry_notice2",
  junifer_ARUDD_unpaidDD1: "junifer/junifer_ARUDD_unpaidDD1",
  junifer_ARUDD_unpaidDD2: "junifer/junifer_ARUDD_unpaidDD2",
  junifer_ARUDD_unpaidDD3: "junifer/junifer_ARUDD_unpaidDD3",
  junifer_AUDDIS_DD_expired: "junifer/junifer_AUDDIS_DD_expired",
  junifer_AUDDIS_no_account: "junifer/junifer_AUDDIS_no_account",
  junifer_bill_final: "junifer/junifer_bill_final",
  junifer_bill: "junifer/junifer_bill",
  junifer_billing_photo_request_chaser:
    "junifer/junifer_billing_photo_request_chaser",
  junifer_billing_photo_request_final:
    "junifer/junifer_billing_photo_request_final",
  junifer_billing_photo_request_gas_initial:
    "junifer/junifer_billing_photo_request_gas_initial",
  junifer_billing_photo_request_initial_dual_fuel:
    "junifer/junifer_billing_photo_request_initial_dual_fuel",
  junifer_billing_photo_request_initial_elec:
    "junifer/junifer_billing_photo_request_initial_elec",
  junifer_cancel_in_cooling_off: "junifer/junifer_cancel_in_cooling_off",
  junifer_DD_Account_Closed_ADDACS: "junifer/junifer_DD_Account_Closed_ADDACS",
  junifer_DD_Account_Transfer_ADDACS:
    "junifer/junifer_DD_Account_Transfer_ADDACS",
  junifer_DD_Amount_Not_Yet_Due: "junifer/junifer_DD_Amount_Not_Yet_Due",
  junifer_DD_ARUDD_1: "junifer/junifer_DD_ARUDD_1",
  junifer_DD_bank_transferred: "junifer/junifer_DD_bank_transferred",
  junifer_DD_cancelled_by_payer_1: "junifer/junifer_DD_cancelled_by_payer_1",
  junifer_DD_cancelled_by_payer_2: "junifer/junifer_DD_cancelled_by_payer_2",
  junifer_DD_cancelled_by_payer_3: "junifer/junifer_DD_cancelled_by_payer_3",
  junifer_DD_cancelled_by_payer_4: "junifer/junifer_DD_cancelled_by_payer_4",
  junifer_DD_referral: "junifer/junifer_DD_referral",
  junifer_disputed_opening_elec_read_request:
    "junifer/junifer_disputed_opening_elec_read_request",
  junifer_disputed_opening_gas_read_request:
    "junifer/junifer_disputed_opening_gas_read_request",
  Junifer_DR_Elec_Dispute_Photo_Chaser:
    "junifer/Junifer_DR_Elec_Dispute_Photo_Chaser",
  Junifer_DR_Elec_dispute_photo_request:
    "junifer/Junifer_DR_Elec_dispute_photo_request",
  Junifer_DR_Elec_Photo_Final_Chaser:
    "junifer/Junifer_DR_Elec_Photo_Final_Chaser",
  Junifer_DR_Gas_Dispute_Photo_Chaser:
    "junifer/Junifer_DR_Gas_Dispute_Photo_Chaser",
  Junifer_DR_Gas_DIspute_Photo_Final_Chaser:
    "junifer/Junifer_DR_Gas_DIspute_Photo_Final_Chaser",
  Junifer_DR_Gas_Dispute_Photo_Request:
    "junifer/Junifer_DR_Gas_Dispute_Photo_Request",
  junifer_erroneous_transfer_20WD: "junifer/junifer_erroneous_transfer_20WD",
  Junifer_ET_Dual_Gain_Suspected: "junifer/Junifer_ET_Dual_Gain_Suspected",
  Junifer_ET_Dual_Loss_Suspected: "junifer/Junifer_ET_Dual_Loss_Suspected",
  Junifer_ET_Elec_Gain_Suspected: "junifer/Junifer_ET_Elec_Gain_Suspected",
  Junifer_ET_Elec_Loss_Suspected: "junifer/Junifer_ET_Elec_Loss_Suspected",
  Junifer_ET_Gain_Suspected_Chaser: "junifer/Junifer_ET_Gain_Suspected_Chaser",
  Junifer_ET_Gas_Gain_Suspected: "junifer/Junifer_ET_Gas_Gain_Suspected",
  Junifer_ET_Gas_Loss_Suspected: "junifer/Junifer_ET_Gas_Loss_Suspected",
  junifer_ET_noET: "junifer/junifer_ET_noET",
  junifer_ET_yesET: "junifer/junifer_ET_yesET",
  junifer_FB1: "junifer/junifer_FB1",
  junifer_FB2: "junifer/junifer_FB2",
  junifer_FB3: "junifer/junifer_FB3",
  junifer_leaving_us: "junifer/junifer_leaving_us",
  junifer_legal_FB1: "junifer/junifer_legal_FB1",
  junifer_legal_FB2: "junifer/junifer_legal_FB2",
  junifer_legal_live_known1: "junifer/junifer_legal_live_known1",
  junifer_legal_live_known2: "junifer/junifer_legal_live_known2",
  junifer_legal_live_occupier1: "junifer/junifer_legal_live_occupier1",
  junifer_meter_read_hello_stranger:
    "junifer/junifer_meter_read_hello_stranger",
  junifer_meter_read_need_a_read: "junifer/junifer_meter_read_need_a_read",
  junifer_meter_read_urgent: "junifer/junifer_meter_read_urgent",
  junifer_new_tariff_about_to_start:
    "junifer/junifer_new_tariff_about_to_start",
  junifer_objection_of_registration:
    "junifer/junifer_objection_of_registration",
  junifer_objection_to_loss: "junifer/junifer_objection_to_loss",
  junifer_objection: "junifer/junifer_objection",
  junifer_payment_schedule_review: "junifer/junifer_payment_schedule_review",
  junifer_prepayment_welcome: "junifer/junifer_prepayment_welcome",
  junifer_PSR_vulnerable: "junifer/junifer_PSR_vulnerable",
  junifer_read_request_normal_240days:
    "junifer/junifer_read_request_normal_240days",
  junifer_read_request_normal_270days:
    "junifer/junifer_read_request_normal_270days",
  junifer_read_request_normal_300days:
    "junifer/junifer_read_request_normal_300days",
  junifer_read_request_normal_60days:
    "junifer/junifer_read_request_normal_60days",
  junifer_read_request_normal1: "junifer/junifer_read_request_normal1",
  junifer_read_request_normal2: "junifer/junifer_read_request_normal2",
  junifer_read_request_opening_latereg:
    "junifer/junifer_read_request_opening_latereg",
  junifer_read_request_opening_reminder:
    "junifer/junifer_read_request_opening_reminder",
  junifer_read_request_opening: "junifer/junifer_read_request_opening",
  junifer_read_request_optin: "junifer/junifer_read_request_optin",
  junifer_sign_up_complete: "junifer/junifer_sign_up_complete",
  junifer_smart_smets1_wakeup: "junifer/junifer_smart_smets1_wakeup",
  junifer_standard_dunning: "junifer/junifer_standard_dunning",
  junifer_tariff_ended_no_new_agreement:
    "junifer/junifer_tariff_ended_no_new_agreement",
  junifer_tariff_ending_soon: "junifer/junifer_tariff_ending_soon",
  junifer_tariff_ending_tomorrow: "junifer/junifer_tariff_ending_tomorrow",
  junifer_variable_price_change: "junifer/junifer_variable_price_change",
  junifer_welcome_pack_tariff_renewal:
    "junifer/junifer_welcome_pack_tariff_renewal",
  leaving_us_upasna: "ark/leaving_us_upasna",
  leaving_us: "ark/leaving_us",
  meter_reading_reminder: "comms-hub/meter_reading_reminder",
  migration_welcome: "welcome/migration_welcome",
  missed_ebss_repayment_fixed_dd: "mandrill/missed_ebss_repayment_fixed_dd",
  missed_ebss_repayment: "mandrill/missed_ebss_repayment",
  moixa: "ark/moixa",
  moneyfacts2020: "legacy/moneyfacts2020",
  newsletter: "legacy/newsletter",
  no_longer_supply_your_energy: "ark/no_longer_supply_your_energy",
  non_psr_smart_meter_not_connected:
    "freshdesk/non_psr_smart_meter_not_connected",
  non_psr_trad_meter_have_reads: "freshdesk/non_psr_trad_meter_have_reads",
  non_psr_trad_meter_no_reads: "freshdesk/non_psr_trad_meter_no_reads",
  not_logged_in: "freshdesk/not_logged_in",
  onboarding_survey: "comms-hub/onboarding_survey",
  // Renamed communication_name (SO-33021).
  onboarding_survey_email: "comms-hub/onboarding_survey",
  opening_read_confirmation: "ark/opening_read_confirmation",
  opening_validated: "ark/opening_validated",
  outbound_photo_request_followup: "account/outbound_photo_request_followup",
  outbound_photo_request: "account/outbound_photo_request",
  password_reset: "account/password_reset",
  // Renamed communication_name (SO-33021).
  "password-reset-email": "account/password_reset",
  payment_confirmation: "comms-hub/payment_confirmation",
  payment_plan_confirmation: "comms-hub/payment_plan_confirmation",
  payment_review_reduce_fee: "ark/payment_review_reduce_fee",
  perfect_customer_trustpilot: "trustpilot/perfect_customer_trustpilot",
  priority_services_register: "mandrill/priority_services_register",
  prize_draw_entry_confirmation: "comms-hub/prize_draw_entry_confirmation",
  // Renamed communication_name (SO-33021).
  loyalty_prize_draw_entry_confirmation:
    "comms-hub/prize_draw_entry_confirmation",
  psr_confirmation_email: "comms-hub/psr_confirmation_email",
  psr_creation_email: "comms-hub/psr_creation_email",
  psr_expiring_email: "comms-hub/psr_expiring_email",
  psr_invitation_email: "comms-hub/psr_invitation_email",
  psr_review_email: "comms-hub/psr_review_email",
  psr_smart_meter_not_connected: "freshdesk/psr_smart_meter_not_connected",
  psr_trad_meter_have_reads: "freshdesk/psr_trad_meter_have_reads",
  psr_trad_meter_no_reads: "freshdesk/psr_trad_meter_no_reads",
  refer_a_friend_general: "mandrill/refer_a_friend_general",
  refer_a_friendB: "ark/refer_a_friendB",
  refer_a_friendC: "ark/refer_a_friendC",
  referee_earned_credit: "comms-hub/referee_earned_credit",
  referral_notify_referrer: "ark/referral_notify_referrer",
  referral_success_referee: "ark/referral_success_referee",
  referral_wouldrecommend: "ark/referral_wouldrecommend",
  refund_expired: "ark/refund_expired",
  refund_failed: "ark/refund_failed",
  refund_successful: "ark/refund_successful",
  rejection_comms_mpxn_in_use_NOT_occupier:
    "account/rejection_comms_mpxn_in_use_NOT_occupier",
  rejection_comms_mpxn_in_use_occupier:
    "account/rejection_comms_mpxn_in_use_occupier",
  renewal: "ark/renewal",
  request_deposit_email: "comms-hub/request_deposit_email",
  resuming_meter_work: "legacy/resuming_meter_work",
  review_us_first_100: "trustpilot/review_us_first_100",
  review_us_referred_a_friend: "mandrill/review_us_referred_a_friend",
  review_us_referred_by_a_friend: "mandrill/review_us_referred_by_a_friend",
  review_us_with_2_fixed_tariffs: "mandrill/review_us_with_2_fixed_tariffs",
  review_with_us: "comms-hub/review_with_us",
  seasonal_summer_payments: "ark/seasonal_summer_payments",
  second_campaign_email: "ark-smbp/second_campaign_email",
  second_follow_up_leads_pipeline_deals:
    "comms-hub/second_follow_up_leads_pipeline_deals",
  second_follow_up_pipedrive_deals:
    "comms-hub/second_follow_up_pipedrive_deals",
  second_follow_up_sales_pipeline_deals:
    "comms-hub/second_follow_up_sales_pipeline_deals",
  serviceable_prospect_solar_quote_request_confirmation:
    "comms-hub/serviceable_prospect_solar_quote_request_confirmation",
  smart_1dayreminder: "ark-smbp/smart_1dayreminder",
  smart_5dayreminder: "ark-smbp/smart_5dayreminder",
  smart_abort_no_access: "ark-smbp/smart_abort_no_access",
  smart_abort_technical: "ark-smbp/smart_abort_technical",
  smart_billalign: "ark-smbp/smart_billalign",
  smart_cancel_or_reschedule: "ark-smbp/smart_cancel_or_reschedule",
  smart_confirmation: "ark-smbp/smart_confirmation",
  smart_install1: "ark-smbp/smart_install1",
  smart_install2: "ark-smbp/smart_install2",
  smart_install3: "ark-smbp/smart_install3",
  smart_installation_success: "ark-smbp/smart_installation_success",
  smart_meter_appointments_available:
    "comms-hub/smart_meter_appointments_available",
  smart_meter_read_freq_opt_in_daily:
    "comms-hub/smart_meter_read_freq_opt_in_daily",
  smart_meter_read_freq_opt_in_hh: "comms-hub/smart_meter_read_freq_opt_in_hh",
  smbp_booking_confirmation: "comms-hub/smbp_booking_confirmation",
  smbp_cancellation_confirmation: "comms-hub/smbp_cancellation_confirmation",
  smbp_external_cancellation: "ark-smbp/smbp_external_cancellation",
  smbp_first_campaign: "ark-smbp/smbp_first_campaign",
  smbp_first_reminder: "ark-smbp/smbp_first_reminder",
  smbp_install_critical_failure: "comms-hub/smbp_install_critical_failure",
  smbp_install_minor_failure: "comms-hub/smbp_install_minor_failure",
  smbp_install_success: "comms-hub/smbp_install_success",
  smbp_second_campaign: "ark-smbp/smbp_second_campaign",
  smbp_second_reminder: "ark-smbp/smbp_second_reminder",
  smbp_third_campaign: "ark-smbp/smbp_third_campaign",
  solar_fakedoortest: "solar/solar_fakedoortest",
  solar_fakedoortest001: "solar/solar_fakedoortest001",
  solar_fakedoortest002: "solar/solar_fakedoortest002",
  solar_quote_followup_01_2023: "solar/solar_quote_followup_01_2023",
  solar_quote_upscaling: "solar/solar_quote_upscaling",
  solar_quote: "comms-hub/solar_quote",
  standard_image: "legacy/standard_image",
  successful_sm_install: "trustpilot/successful_sm_install",
  svt_comms: "junifer/svt_comms",
  svt_dd_increase: "comms-hub/svt_dd_increase",
  svt_working_smart_meters: "freshdesk/svt_working_smart_meters",
  switch_to_daily_reads: "account/switch_to_daily_reads",
  tariff_ending_60_days: "comms-hub/tariff_ending_60_days",
  tariff_ending_60days: "ark/tariff_ending_60days",
  tariff_ending_second_reminder: "comms-hub/tariff_ending_second_reminder",
  template: "legacy/template",
  third_campaign_email: "ark-smbp/third_campaign_email",
  third_follow_up_leads_pipeline_deals:
    "comms-hub/third_follow_up_leads_pipeline_deals",
  third_follow_up_pipedrive_deals: "comms-hub/third_follow_up_pipedrive_deals",
  third_follow_up_sales_pipeline_deals:
    "comms-hub/third_follow_up_sales_pipeline_deals",
  third_party_instructions_email: "comms-hub/third-party-instructions-email",
  // Nova sends this communication_name hyphenated, unlike the key above (SO-33021).
  "third-party-instructions-email": "comms-hub/third-party-instructions-email",
  unserviceable_prospect_solar_quote_request_confirmation:
    "comms-hub/unserviceable_prospect_solar_quote_request_confirmation",
  update_email_verify: "comms-hub/update_email_verify",
  usage_update: "legacy/usage_update",
  variable_price_alreadyonSOOC: "legacy/variable_price_alreadyonSOOC",
  variable_price_willbeonSOOC: "legacy/variable_price_willbeonSOOC",
  wakingSMETS2: "ark-smbp/wakingSMETS2",
  welcome_email: "welcome/welcome_email",
  welcome_pack_PCW_noMSN: "legacy/welcome_pack_PCW_noMSN",
  welcome_pack_PCW: "legacy/welcome_pack_PCW",
  welcome_seg: "legacy/welcome_seg",
  whd_application_received: "ark-whd/whd_application_received",
  whd_approved: "ark-whd/whd_approved",
  whd_closed_account: "ark-whd/whd_closed_account",
  whd_core_group: "ark-whd/whd_core_group",
  whd_da_invite: "mandrill/whd_da_invite",
  whd_fap_invite: "mandrill/whd_fap_invite",
  whd_paid_mandrill: "ark/whd_paid_mandrill",
  whd_paid: "ark-whd/whd_paid",
  whd_rejected_approved: "ark-whd/whd_rejected_approved",
  whd_rejected_credited: "ark-whd/whd_rejected_credited",
  whd_rejected: "ark-whd/whd_rejected",
  whd_rwg_invite: "mandrill/whd_rwg_invite",
  whd_sct_broader_group_missed_3_payments:
    "mandrill/whd_sct_broader_group_missed_3_payments",
  whd_sct_broader_group_psr: "mandrill/whd_sct_broader_group_psr",
}

export function emailTemplateCatalogueUrl(
  communicationName: string | null,
): string | null {
  if (!communicationName) return null
  const path = EMAIL_TEMPLATE_PATHS[communicationName]
  return path ? `${CATALOGUE_BASE}/${path}.html` : null
}
